const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export const makeEmailValidator = (message: string) => (value: string) =>
    !value || !emailRegex.test(value) ? message : undefined;
export const makeRequiredValidator = (message: string) => (value: string) => {
    if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && value === "")
    )
        return message;
    return undefined;
};
export const makeCheckboxValidator = (message: string) => (value: boolean) =>
    !value ? message : undefined;
